import './Layout.less';

export const prefix = 'oc-c-layout';

export { default } from './Layout';